
import { useEffect, useState } from 'react';

import { AiOutlineClose } from "react-icons/ai";

import { AiOutlineMinusCircle, AiFillPlusCircle, AiOutlineCaretDown } from "react-icons/ai"
import axios from 'axios';
import "../../../pages/userAdminPanelPages/Styles/Model.css"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import userRequest from "../../../utils/userRequest";
import { handleUserError } from '../../../utils/error';
import ViewportMeta from '../../../utils/ViewportMeta';
import { useTranslation } from 'react-i18next';
import Sidebarfats from '../../sidebar/Sidebarfats';

function Model(props) {
  const { t, i18n } = useTranslation()

  // Retrieve the value with the key "myKey" from localStorage
  const myValue = localStorage.getItem("userId");
  // console.log(myValue)
  const location = useLocation();
  const {
  country,
  countryName,
  state,
  stateName,
  city,
  cityName,
  area,
  department,
  departmentCode,
  businessName,
  bldgName,
  bldgAddress,
  buildingNo,
  floorNo,
} = location?.state || {};

  const navigate = useNavigate();


  const [selectedValue, setSelectedValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };
  const [category, setcategory] = useState([])
  const [Insert, setInsert] = useState([])
  const [filterValue, setFilterValue] = useState('');
  const [BrandType, setBrandType] = useState([])
  const [sendForBarcode, setSendForBarcode] = useState(false);
  const [Type, setType] = useState([])
  const [Brand, setBrand] = useState([])
  const [newBrand, setNewBrand] = useState('')
  const [data, setData] = useState([])
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [allSelectedRows, setAllSelectedRows] = useState([]);
  const [newData, setNewData] = useState({
    type: "",
    model: "",
    qty: 1,
    assetClass: "",
    mcode: "",
    scode: "",
    majorDesc: "",
    minorDesc: "",
  })


  const handleDataSubmit = (e) => {
    e.preventDefault();
    setData([newData, ...data])
  }

  const handleBrandChange = (e) => {
    setNewBrand(e.target.value)
    setNewData((prev) => {
      return { ...prev, type: e.target.value }
    })
  }

  const handleChange = (e) => {
    const selectedCategory = JSON.parse(e.target.value);
    setSelectedValue(selectedCategory.SubDescriptione);
    setNewData((prev) => {

      return {
        ...prev, assetClass: selectedCategory.SubDescription,
        mcode: selectedCategory.MainCategoryCode,
        scode: selectedCategory.SubCategoryCode,
        majorDesc: selectedCategory.MainDescription,
        minorDesc: selectedCategory.SubDescription,

      }
    })


    userRequest.post("/GetmakelistById", {
      "TblMakeMainCode": selectedCategory?.SubCategoryCode,
      "tblMajorCode": selectedCategory?.MainCategoryCode,
    })
      .then(response => {
        setBrand(response?.data?.recordset || [])
      })
      .catch(error => {
        console.log(error);
      });

  };


  const handleFilterChange = (e) => {
    setFilterValue(e.target.value);
  };


  const handleInputChange = (e) => {
    console.log(e.target.name, e.target.value)
    setNewData((prev) => {
      return { ...prev, [e.target.name]: e.target.value }
    })
  }
  const handleAddBrand = (e) => {
    // push the new brand to the brand array
    // setBrand with newbrand and id 
    // setNewBrand to empty string
    // close the 
    // console.log("newData")
    // console.log(newData)
    // let currentCategory = newData.filter((item) => item.SubDescription === newData.assetClass);

    // console.log(currentCategory)
    try {
      userRequest.post("/PostMakeList",
        {
          TblMakeName: newBrand,
          TblMakeMainCode: newData.scode,
          tblMajorCode: newData.mcode,

        }


      )
      e.preventDefault();
      setBrand([...Brand, { id: Brand.length + 1, TblMakeName: newBrand }])
      setNewData((prev) => {
        return { ...prev, type: newBrand }
      })
      // console.log(newBrand)
      // console.log(Brand)
      setNewBrand('')
      togglePopup()
    } catch (error) {
      console.log(error)
      handleUserError(error)
    }
  }

  //Category Api
  useEffect(() => {


    userRequest.get("/GetAllMAINSUBSeriesNo", data)
      .then(response => {
        console.log(response?.data);
        setcategory(response?.data);
        setNewData((prev) => {
          return {
            ...prev, assetClass: response?.data[0]?.SubDescription,
            mcode: response?.data[0]?.MainCategoryCode,
            scode: response?.data[0]?.SubCategoryCode,
            majorDesc: response?.data[0]?.MainDescription,
            minorDesc: response?.data[0]?.SubDescription,

          }
        })
        // console.log("newData")
        // console.log(newData)


        userRequest.post("/GetmakelistById", {
          "TblMakeMainCode": response?.data[0]?.SubCategoryCode,
          "tblMajorCode": response?.data[0]?.MainCategoryCode,
        })
          .then(response => {
            setBrand(response?.data?.recordset || [])
            // console.log("newData")
            // console.log(response?.data?.recordset[0]?.TblMakeName)
            setNewData((prev) => {
              return { ...prev, type: response?.data?.recordset[0]?.TblMakeName }
            })

          })
          .catch(error => {
            // console.log(error);
            handleUserError(error)
          });

      })
      .catch(error => {
        // console.error(error);
        handleUserError(error)
      });
  }, []);

  const handleApiCall = async () => {
    const callAPI = async (type, model, qty, assetClass, mcode, scode, majorDesc, minorDesc) => {
      // let assetDescription = minorDesc + " " + type + " " + model;
      let assetDescription = (minorDesc ? minorDesc : "") + (type ? " " + type : "") + (model ? " " + model : "");
      try {
        const response = await userRequest.post(
          "/PostAssetMasterEncodeAssetCapture",
          {
            QTY: 1,
            MajorCategory: mcode || "",
            // BusinessUnit: BusinessUnit,
            MajorCategoryDescription: majorDesc || "",
            MInorCategory: scode,
            MinorCategoryDescription: minorDesc || "",
            aSSETdESCRIPTION: assetDescription || "",

            cOUNTRY: country || "",
            rEGION: area || "",
            CityName: cityName || "",
            DaoName: department || "",

            BUILDINGNO: buildingNo || "",
            FLOORNO: floorNo || "",

            ModelofAsset: model || "",
            Manufacturer: type || "",

            buildingName: bldgName || "",
            buildingAddress: bldgAddress || "",
            UserLoginID: myValue || "",
          }
        );

        if (response.status === 200) {
          // console.log(response?.data);
          // console.log("status is 200");
          // callsMade++; // increment number of API calls made
          // console.log("callsMade", callsMade)
          if (callsMade === totalCalls) { // check if all API calls have been made
            swal({
              title: "Record Inserted",
              text: "Record Insert Successfully Thank you",
              icon: "success"
            });
            navigate('/member/assets');
          }

        } else {
          // console.log("Not 200");
        }
      } catch (error) {
        // console.log(error);
        swal({
          title: "Error",
          text: "An error occurred while processing your request",
          icon: "warning"
        });
        handleUserError(error);

      }
    };

    let tableData = [...data];

    const totalCalls = data.reduce((acc, row) => acc + row.qty, 0); // calculate total number of API calls needed
    // console.log("totalcalls", totalCalls)

    let callsMade = 0; // keep track of number of API calls made


    // Loop through each row in allSelectedRows
    for (const row of data) {
      // console.log(row.qty);
      // console.log("row is working");

      callsMade++; // 1

      if (row.qty > 1) {
        // console.log("row is in if");
        for (let i = 0; i < row.qty; i++) {
          await callAPI(row.type, row.model, row.qty, row.assetClass, row.mcode, row.scode, row.majorDesc, row.minorDesc);
          if (i === row.qty - 1) {
            continue
          }
          callsMade++;
        }
      } else {
        // console.log("row is in else");
        // await callAPI(row.rowData.type, row.rowData.model, row.rowData.qty, row.rowData.assetClass, row.rowData.mcode, row.rowData.scode, row.rowData.majorDesc, row.rowData.minorDesc);
        await callAPI(row.type, row.model, row.qty, row.assetClass, row.mcode, row.scode, row.majorDesc, row.minorDesc);

      }
    }
  };


  const handleRowClick = (rowData, index) => {

    setSelectedRowIndex(index);
    setQuantity(data[index].qty);
    const selectedRowIndex = selectedRow.findIndex(selectedItem => selectedItem.index === index);
    if (selectedRowIndex === -1) {
      // Row is not already selected, so add it to selectedRow and AllSelectedRow
      const newSelectedRow = { rowData, index };
      setSelectedRow([...selectedRow, newSelectedRow]);
      setAllSelectedRows([...allSelectedRows, newSelectedRow]);
    } else {
      // Row is already selected, so remove it from selectedRow and AllSelectedRow
      const newSelectedRow = [...selectedRow];
      newSelectedRow.splice(selectedRowIndex, 1);
      setSelectedRow(newSelectedRow);

      const newAllSelectedRow = [...allSelectedRows];
      newAllSelectedRow.splice(selectedRowIndex, 1);
      setAllSelectedRows(newAllSelectedRow);
    }
    // console.log("check")
    // console.log(allSelectedRows)
  };

  // const handleIncrement = () => {
  //   if (selectedRow.length > 0) {
  //     const selectedRowIndex = selectedRow[0].index;
  //     const updatedRow = { ...data[selectedRowIndex] };
  //     updatedRow.qty++;
  //     setQuantity(updatedRow.qty);
  //     const newData = [...data];
  //     newData[selectedRowIndex] = updatedRow;
  //     setData(newData);
  //   }
  // };

  // const handleIncrement = () => {
  //   if (selectedRow !== null) {
  //     const updatedRow = { ...selectedRow };
  //     updatedRow.qty++;
  //     setQuantity(updatedRow.qty);
  //     // setNewData(updatedRow);
  //     const newData = [...data];
  //     newData[selectedRowIndex] = updatedRow;
  //     setData(newData);
  //     setSelectedRow(updatedRow);
  //   }
  // };

  const handleIncrement = () => {
    if (selectedRowIndex !== null) {
      const updatedRow = { ...data[selectedRowIndex] };
      updatedRow.qty++;
      setQuantity(updatedRow.qty);
      const newData = [...data];
      newData[selectedRowIndex] = updatedRow;
      setData(newData);
    }
  };
  // const handleDecrement = () => {
  //   if (selectedRow !== null) {
  //     const updatedRow = { ...selectedRow };
  //     if (updatedRow.qty == 1) {
  //       // const shouldDelete = window.confirm('Are you sure you want to delete this record?');
  //       const shouldDelete = swal({
  //         title: "Are you sure?",
  //         text: "Are you sure you want to delete this record?",
  //         icon: "warning",
  //         dangerMode: true,
  //       })
  //         .then(willDelete => {
  //           if (willDelete) {
  //             swal("Deleted!", "Your Record has been deleted!", "success");
  //           } //Alert add
  //         });
  //       if (shouldDelete) {
  //         const newData = [...data];
  //         newData.splice(selectedRowIndex, 1);
  //         setData(newData);
  //         setSelectedRow(null);
  //         setSelectedRowIndex(null);
  //         return;
  //       }
  //       return;

  //     }
  //     updatedRow.qty--;
  //     setQuantity(updatedRow.qty);
  //     const newData = [...data];
  //     newData[selectedRowIndex] = updatedRow;
  //     setData(newData);
  //     setSelectedRow(updatedRow);
  //   }
  // };


  const handleDecrement = () => {
    if (selectedRowIndex !== null) {
      const updatedRow = { ...data[selectedRowIndex] };
      if (updatedRow.qty === 1) {
        // Confirm deletion
        const shouldDelete = window.confirm('Are you sure you want to delete this record?');
        if (shouldDelete) {
          // Remove row from data array
          const newData = [...data];
          newData.splice(selectedRowIndex, 1);
          setData(newData);
          setSelectedRow(null);
          setSelectedRowIndex(null);
        }
      } else {
        // Decrement quantity
        updatedRow.qty--;
        setQuantity(updatedRow.qty);
        const newData = [...data];
        newData[selectedRowIndex] = updatedRow;
        setData(newData);
        setSelectedRow(updatedRow);
      }
    }
  };

  return (
    <>
      <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}>
          <ViewportMeta />
          <div className="parent-container mt-10">
            <div className={`window-container ${i18n.language === 'ar' ? 'direction-rtl' : 'direction-ltr'}`}>

              {isOpen && (
                <div className="popup-wrapper">
                  <div className="popup">
                    <div className="close-btn" onClick={togglePopup}>
                      <AiOutlineClose />
                    </div>

                    <span className='add-input-container'>
                      <label htmlFor="brand-input">Type</label>
                      <input type="text" name="brand-input" id="brand-input"
                        onChange={(e) => {
                          setNewBrand(e.target.value)
                        }
                        }
                      />
                    </span>
                    <div className="save-btn-container">

                      <button
                        onClick={handleAddBrand}
                      >{t("Save")}</button>
                    </div>
                  </div>
                </div>
              )}
              <div className="category-container">
                
                <p>{t("CATEGORY")}</p>
                {/* CREATE SELECT OPTION CONTAINER */}

                <select value={selectedValue} onChange={handleChange}>

                  {/* <option value="">Select an option</option> */}
                  {category.map((category) =>
                  (category.SubDescription && category.SubDescription.toLowerCase().includes(filterValue)
                    ?
                    <option className="text-center" key={category.TblMAINSUBSeriesNoID} value={JSON.stringify(category)} >
                      {category.SubDescription}

                    </option>
                    : null
                  ))}


                </select>
              </div>

              <div className="filter-container">

                <p>{t("FILTER By")}:</p>
                <input type="text" name="filter" id="filter"

                  onChange={handleFilterChange}
                />

              </div>
              <div className="brand-model-btn-container">
                <div className="brand-container">
                  <span>
                    <label htmlFor="brand">{t("BRAND/TYPE")}</label>
                    <select value={selectedValue} onChange={handleBrandChange}
                      name="brand" id="brand"
                    >
                      {/* {Brand && <option value="">Select an option</option>} */}
                      {Brand.map(({ id, TblMakeName }) => (
                        <option className="text-center" key={id} value={TblMakeName}>
                          {TblMakeName}
                        </option>
                      ))}
                    </select>
                  </span>

                  <AiFillPlusCircle className='brand-add-icon'

                    onClick={togglePopup}
                  />

                </div>
                <div className="model-container">
                  <label htmlFor="model">{t("MODEL")}</label>
                  <input type="text" name="model"
                    onChange={handleInputChange} />

                </div>
                <div className="submit-btn-container" onClick={handleDataSubmit}>

                  <button type='submit' className='submit-btn'>
                    {/* arrow icon */}
                    <span>
                      <AiOutlineCaretDown className='add-to-table-icon' />

                    </span>

                  </button>
                </div>

              </div>
              <div className="increment-decrement-container">
                <AiOutlineMinusCircle className='decrement-icon' onClick={
                  handleDecrement
                } />

                <span className='count'>
                  {/* {newData.qty} */}
                  {quantity}
                  {/* {updatedRow.qty} */}
                </span>
                <AiFillPlusCircle className='increment-icon' onClick={handleIncrement
                } />
              </div>
              {/* // creae excel like Tables  */}

              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>{t('TYPE')}</th>
                      <th>{t('MODEL')}</th>
                      <th>{t('QTY')}</th>
                      <th>{t('ASSET CLASS')}</th>
                      <th>{t('MCODE')}</th>
                      <th>{t('SCODE')}</th>
                      <th>{t('MAJOR DESCRIPTION')}</th>
                      <th>{t('MINOR DESCRIPTION')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((data, index) => {
                      // Check if the row is selected
                      {/* const isSelected = selectedRow.some(selectedItem => selectedItem.index === index); */ }
                      return <tr
                        key={index}
                        onClick={() => handleRowClick(data, index)}
                        // style={{ backgroundColor: isSelected && 'orange' }}
                        style={{ backgroundColor: selectedRowIndex === index && 'orange' }}
                      // style={{ backgroundColor: isSelected && 'orange' }}
                      >
                        <td>{data.type}</td>
                        <td>  {data.model}</td>
                        <td>    {data.qty}</td>
                        <td>   {data.assetClass}</td>
                        <td>   {data.mcode}</td>
                        <td>     {data.scode}</td>
                        <td>{data.majorDesc}</td>
                        <td>{data.minorDesc}</td>
                      </tr>
                    })}
                  </tbody>
                </table>
              </div>

              <div className={`bottom-btn-container justify-between flex ${i18n.language==='ar'?'flex-row-reverse':'flex-row'}`}>
                <Link to='/member/userdetails'>
                  <button>{t("Back")}</button>
                </Link>

                <h1>UserId: {myValue}</h1>
                {/* onClick={() => setSendForBarcode(true)} */}
                <button onClick={handleApiCall}>{t("Send for Barcode")}</button>
              </div>


            </div>
          </div >
        </div>
    </>
  );
}

export default Model;